import { z } from 'zod'
import { PowerMeterForm } from 'src/Libs/installations'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { ValidationMessageKeys } from 'src/Configuration/validation'
import { PlannedPowerMeterModel, PowerMeterFormDeviceType } from 'src/Libs/installations/models'
import {
  getDefaultPowerMeterFormDeviceType,
  isRootPowerMeter,
  isPlannedPowerMeterType,
  METER_TYPE_INTERNAL_ROOT_POWER_METER,
  POWER_METER_FORM_VALUE_BY_TYPE,
} from 'src/Libs/installations/utils/power-meter-type'

export const usePowermeterFormInitializer = (
  powermeter?: PlannedPowerMeterModel,
  allPowermeters: Nullable<PlannedPowerMeterModel>[] = []
): { validationSchema: z.Schema; initialValues: PowerMeterForm } => {
  const { t } = useCustomTranslation()
  const plannedPowerMeter = powermeter

  const validationSchema = z.object({
    index: z.number().optional(),
    name: z
      .string()
      .trim()
      .min(3, t(ValidationMessageKeys.lengthMin, { value: 3 }))
      .max(50, t(ValidationMessageKeys.lengthMax, { value: 50 })),
    deviceType: z.nativeEnum(PowerMeterFormDeviceType).optional(),
    wiringMode: z.union([z.literal('Normal'), z.literal('Inverted')]),
    useCT: z.boolean(),
    ratioCT: z.string(),
    serialNumber: z.string().optional(),
    powerMeterIpAddress: z.string().optional(),
  })

  let deviceType = getDefaultPowerMeterFormDeviceType(allPowermeters, powermeter)

  if (powermeter && isRootPowerMeter(powermeter)) {
    deviceType = METER_TYPE_INTERNAL_ROOT_POWER_METER
  } else if (plannedPowerMeter?.deviceType && isPlannedPowerMeterType(plannedPowerMeter.deviceType)) {
    deviceType = POWER_METER_FORM_VALUE_BY_TYPE[plannedPowerMeter.deviceType]
  }

  const initialValues = {
    name: powermeter?.deviceName ?? '',
    deviceType,
    wiringMode: powermeter?.wiringMode ?? 'Normal',
    useCT: false,
    ratioCT: '400:5',
    serialNumber: powermeter?.mediaParameters?.serialNumber ?? '',
    powerMeterIpAddress: powermeter?.mediaParameters?.communicationInterfaceAddress ?? '',
  }

  return { validationSchema, initialValues }
}
